import { useMemo } from "react";
import useNavContext from "../../hooks/useNavContext";
import { getNavModules } from "./navModules";
import useNavPrefs from "./navPrefs";

/** The new menu's modules for this person, plus their saved preferences. */
export default function useNavModules(vendorData) {
  const { navGroups, persona, approvalsPending } = useNavContext(vendorData);
  const prefs = useNavPrefs();
  const nav = useMemo(
    () => getNavModules(navGroups, { splitDealership: prefs.splitDealership }),
    [navGroups, prefs.splitDealership]
  );
  const byKey = useMemo(() => new Map(nav.items.map((i) => [i.key, i])), [nav.items]);
  return { ...nav, byKey, navGroups, persona, approvalsPending, prefs };
}
